export default __webpack_public_path__ + "static/media/dog1.09c7fd00.JPG";